import {
    PRINT_WITH_PRICE,
    PRINT_WITHOUT_PRICE,
    WINDOW_PRINT_TRIGGERED,
} from '../actions/pdpRespPrintActions';

const initialState = {
    printWithPrice: true,
    triggerWindowPrint: false,
};

export function pdpRespPrintReducer(state, action) {
    switch (action.type) {
        case PRINT_WITH_PRICE:
            return {
                ...state,
                printWithPrice: true,
                triggerWindowPrint: true,
            };
        case PRINT_WITHOUT_PRICE:
            return {
                ...state,
                printWithPrice: false,
                triggerWindowPrint: true,
            };
        case WINDOW_PRINT_TRIGGERED:
            return {
                ...state,
                triggerWindowPrint: false,
            };
    }

    return state || initialState;
}

export default pdpRespPrintReducer;
